<template>
	<Link 
		class="hover:underline text-sm" 
		:class="{'font-bold': active }"
	>
		<slot />
	</Link>
</template>

<script>

export default {
	props: {
		active: Boolean,
	}
};
</script>